import { defineStore } from 'pinia';
import ConversationApi from 'dashboard/api/inbox/conversation';

// Pending schedules per conversation. The dialog that creates them and the thread that shows them
// live in different parts of the screen, so they read and write the same list here.
export const useScheduledMessagesStore = defineStore('scheduledMessages', {
  state: () => ({
    byConversationId: {},
  }),

  getters: {
    forConversation: state => conversationId =>
      state.byConversationId[conversationId] || [],
  },

  actions: {
    async fetch(conversationId) {
      const { data } =
        await ConversationApi.getScheduledMessages(conversationId);
      this.byConversationId[conversationId] = data.payload;
    },

    async create({ conversationId, ...attributes }) {
      const { data } = await ConversationApi.createScheduledMessage({
        conversationId,
        ...attributes,
      });
      this.byConversationId[conversationId] = [
        ...this.forConversation(conversationId),
        data,
      ].sort((a, b) => a.scheduled_at - b.scheduled_at);
    },

    async cancel({ conversationId, id }) {
      await ConversationApi.cancelScheduledMessage({ conversationId, id });
      this.byConversationId[conversationId] = this.forConversation(
        conversationId
      ).filter(message => message.id !== id);
    },
  },
});
